import { Box, styled } from '@mui/material'

export const StyledPhoneContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'valid',
})<{ valid: boolean }>(({ theme, valid }) => ({
  '& .react-tel-input': {
    borderRadius: '8px',
    border: 'none !important',
    fontSize: '1rem',
    transition: theme.transitions.create(['border'], {
      duration: theme.transitions.duration.standard,
    }),
  },

  // BAYRAK CONTAINER
  '& .selected-flag': {
    width: '100px !important',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '8px 0px 0px 8px !important',
    alignItems: 'center',
    border: '1px solid',
    borderColor: valid
      ? theme.palette.darkGray.main
      : theme.palette.mediumGray.main,

    transition: theme.transitions.create(['border'], {
      duration: theme.transitions.duration.short,
    }),
    backgroundColor: 'white',

    '&:focus': {
      backgroundColor: 'white',
      borderColor: theme.palette.mediumGreen.main,
    },

    '& .flag': {
      // transform: 'scale(1.5)',
      left: '30% !important',
    },
  },

  '& .flag-dropdown': {
    borderLeft: 'none !important',
    borderTop: 'none !important',
    borderBottom: 'none !important',
    transition: theme.transitions.create(['background-color', 'border'], {
      duration: theme.transitions.duration.standard,
    }),
  },

  // Container
  '& .form-control': {
    width: '100% !important',
    height: '48px !important',
    marginLeft: '70px !important',
    outline: 'none !important',
    borderRadius: '0px 8px 8px 0px !important',
    border: '1px solid',
    fontSize: '1rem !important',
    borderColor: valid
      ? theme.palette.mediumGreen.main
      : theme.palette.mediumGray.main,
    transition: theme.transitions.create(['background-color', 'border'], {
      duration: theme.transitions.duration.standard,
    }),
    backgroundColor: 'white',
    '&:focus': {
      boxShadow: 'none !important',
    },

    '&:not(:placeholder-shown)': {
      '&:focus': {
        borderColor: theme.palette.mediumGreen.main,
      },
      borderColor: theme.palette.darkGray.main,
    },
  },

  '&: focus-within': {
    '& .selected-flag': {
      borderColor: theme.palette.mediumGreen.main,
    },
    '& .form-control': {
      borderColor: theme.palette.mediumGreen.main,
    },
  },
}))

export const StyledModalIconWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.lightGreen.main,
  padding: '1.375rem',
  borderRadius: '50%',
}))
